<template>
  <section class="uploader" >
    <div>
      <el-upload v-loading='loading' v-if="!fileFuther.status" class="button mr20 blue"
        :action="FileUploadURL"  :show-file-list="false" :accept="accept"  :file-list="fileFuther.fileList"
        :on-success="handleSuccess" :on-error="handleUploadError" :before-upload="handlebeforeUpload"  :on-exceed="handleExceed"  multiple  :limit="30">
          <el-button slot="trigger">上传</el-button>
        </el-upload>
        <div class="mr20 blue" v-if="downFlag && fileFuther.canDownload">
          <el-link type="primary" :underline="false" :href="fileFuther.downloadUrl" :download="fileFuther.downloadUrl" 
          :title="fileFuther.fileName"  :name="fileFuther.fileName"  target="_blank">{{downText}}</el-link>
        </div>
        <el-link style="margin-right:20px;line-height: 40px;line-height: 1;" v-if="fileFuther.fileList && fileFuther.fileList.length!=0  && fileFuther.fileList[0].fileUrl!='无'" type="info" :underline="false"  target="_blank">点击下方列表可预览</el-link>
        <el-link v-else style="margin-right:20px;line-height: 1;"  type="info" :underline="false"  target="_blank">{{orNo? '无': ''}}</el-link>
      <!-- 企业抵押贷款页面的特殊性。因接口没加字段，所以只能先拎出来写死，以达到功能的实现 -->
      <el-radio-group v-model="radioValue" size="mini" @change='changeRadio($event)' 
        v-if="fileFuther.fileType=='Capital-verification-report'||
        fileFuther.fileType=='audit-report'|| 
        fileFuther.fileType=='accounting-statement'||
        fileFuther.fileType=='bank-statement'||
        fileFuther.fileType=='lease-contract'||
        fileFuther.fileType=='purchase-sale-contract'">
        <el-radio label="无">无</el-radio>
      </el-radio-group>
    </div> 
    <div v-if="fileFuther.fileList && fileFuther.fileList.length!=0 && fileFuther.fileList[0].fileUrl!='无'">
      <span v-for="(item,index) in fileFuther.fileList" :key='index' style="display:flex; align-items:center;">
        <el-link  type="primary"  class="mr20 zindex-1" :underline="false" target="_blank" :href="item.fileUrl" style=" color: #007BFF;" >{{item.fileName}}</el-link>
        <i v-if="!fileFuther.status" class="el-icon-close" style='margin-left:-10px; margin-top:5px; cursor:pointer;'  @click="del(index)"></i>
      </span>
    </div>
  </section>
</template>

<script>
import BASE from '@/api/base'
import ImageCompressor from 'image-compressor.js'
export default {
  props: {
    fileFuther: Object,
    downFlag: {
      default: true,
      type: Boolean
    },
    downText: {
      default: '下载模板',
      type: String
    },
    orNo:false, // 没有url的时候是否显示"无"
  },
  data() {
    return {
      FileUploadURL: this.$common.FileUploadURL,
      loading: false,
      centerDialogVisible: false,
      fileFutherData:{},
      fileList: [],
      radioValue:'', // 企业抵押贷款页面的特殊性: 对于必填项，如果用户没有，让用户单选 '无'
      accept:'image/*,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/*,application/msword,application/vnd.ms-excel'
    }
  },

  watch: {
    fileFuther: function(){ // 监听父组件的变化
      this.fileFutherData = this.fileFuther
    },
  },
  mounted() {
    this.fileReader = new FileReader();
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多可上传8份文件`);
    },
    handleSuccess(res, file, fileList) {
      this.loading = false
      if (res.code!=1000) {
        this.$message.error('上传失败')
        return
      }
      if(this.radioValue =='无'){
          this.fileFuther.fileList = [];
      }
      fileList.forEach(item =>{
        if(item && item.response){
          this.$set(item,'fileName',this.fileFuther.fileName)
          this.$set(item,'fileType',this.fileFuther.fileType)
          this.$set(item,'fileTypeType',this.fileFuther.type)
          this.$set(item,'role',this.fileFuther.role)
          this.$set(item,'maxNumber',this.fileFuther.maxNumber)
          this.$set(item,'canDownload',this.fileFuther.canDownload)
          this.$set(item,'downloadUrl',this.fileFuther.downloadUrl)
          this.$set(item,'content','')
          this.$set(item,'fileUrl',item.response.data)
        }
      })
      this.fileFuther.fileList = fileList
      this.radioValue = ''; 
      this.$forceUpdate(); //多层循环数据无法直接渲染到父组件，手动更新
      // console.log(this.fileFuther.fileList,'this.fileFuther.fileList')
      this.$message.success('上传成功')
    },

    handleUploadError() {
      this.loading = false
      this.$message.error('上传失败')
    },

    handlebeforeUpload(file) {
      console.log(file.type,'===file.type')
      this.loading = true
      // // 这里做可以做文件校验操作
      let isImg = false
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === "application/pdf" || file.type === 'application/msword' || file.type === 'application/vnd.ms-excel'|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type ==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        isImg = true;
      }
      if (!isImg) {
        this.loading = false
        this.$message.error('上传文件只能是JPG、PNG、PDF、WORD、EXCEL格式 !')
      }
      let isLt5M = file.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.loading = false
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      // if(this.fileFuther.fileType=='4' && this.fileFuther.fileList.length==5){
      //   return this.$message.error('至多上传5个文件！')
      // }
      return isImg && isLt5M
    },

    del(index) {
      let length = this.fileFuther.fileList.length;
      if (length === 1) {
        this.fileFuther.fileList = []
        this.$forceUpdate();
        return
      }
      this.fileFuther.fileList.splice(index, 1);
      this.$forceUpdate();
    },
    async downloadFile(url,name){
      let path = `${BASE.ZCT_API}/file/download?url=${encodeURI(url)}&name=${encodeURI(name)}`;
      window.location.href = path;
    },

    // 企业抵押贷款页面的特殊性
    changeRadio(val){
      this.fileFuther.fileList = [];
      this.fileFuther.fileList[0] = {
        fileName: this.fileFuther.fileName,
        fileUrl: this.radioValue,
        fileType: this.fileFuther.fileType,
        fileTypeType: this.fileFuther.type,
        content: this.radioValue,  
      }
      this.$forceUpdate();
    },
  }
}
</script>
<style scoped lang="scss">
.uploader {
  width: auto;
  height: auto;
  .blue{
    cursor: pointer;
    color: #007BFF;
    border: 1px solid #007BFF;
    font-size: 10px;
    border-radius: 2px;
    height:30px;
    line-height: 30px;
    width: 70px;
    display: inline-block;
    text-align:center;
    line-height: 1;
    .el-upload{
      .el-button{
        height:30px;
        line-height: 30px;
        width: 70px;
        display: inline-block;
        border: none;
        padding: 0;
        margin: 0;
        color: #007BFF;
      }
    }
    .el-link{
      color: #007BFF;
      height:30px;
      line-height: 30px;
    }
    &:hover {
      background:  none;
    }
  }
}
.zindex-1 {
  z-index: 1;
}
</style>